export default __webpack_public_path__ + "static/media/logo-soyvida-login.798e4391.png";